export const getReadOnlyFields = configurations => {
    const fields = []

    for (const section of Object.values(configurations)) {
        for (const input of Object.values(section.groups)) {
            for (const [key, value] of Object.entries(input?.values)) {
                if (value?.read_only) {
                    fields.push(key)
                }
            }
        }
    }

    return fields
}

export const formatDataForAPI = (data, readOnlyFields) => {
    const values = {}

    for (const [key, value] of Object.entries(data)) {
        if (!readOnlyFields.includes(key)) {
            values[key] = value
        }
    }

    return values
}
